
(function(){
  var DUMPLING_PRODUCTS = [15559457079369, 15559457144905];
  var GIFT_VARIANT = 55748268490825;
  var MARK = "typhoon-dj-202608";
  var START = Date.parse("2026-08-06T16:00:00Z");
  var END = Date.parse("2026-08-31T15:59:59Z");
  if (Date.now() < START || Date.now() > END) return; // 活動視窗外自動停用
  var busy = false;

  function desired(q){ return q >= 4 ? 2 : (q >= 3 ? 1 : 0); }

  function swapSection(html, sel){
    var doc = new DOMParser().parseFromString(html, "text/html");
    var src = doc.querySelector(sel), dst = document.querySelector(sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function refresh(){
    var onCart = location.pathname.replace(/\/$/, "") === "/cart";
    if (onCart) { location.reload(); return Promise.resolve(); }
    return fetch("/?sections=cart-drawer,cart-icon-bubble").then(function(r){ return r.json(); }).then(function(s){
      if (s["cart-drawer"]) swapSection(s["cart-drawer"], "#CartDrawer");
      if (s["cart-icon-bubble"]) {
        var dst = document.getElementById("cart-icon-bubble");
        if (dst) { var doc = new DOMParser().parseFromString(s["cart-icon-bubble"], "text/html"); dst.innerHTML = doc.body.innerHTML; }
      }
    }).catch(function(){});
  }

  function sync(){
    if (busy) return;
    busy = true;
    fetch("/cart.js").then(function(r){ return r.json(); }).then(function(cart){
      var dq = 0, line = null;
      cart.items.forEach(function(i){
        if (DUMPLING_PRODUCTS.indexOf(i.product_id) >= 0) dq += i.quantity;
        if (i.variant_id === GIFT_VARIANT && i.properties && i.properties._auto_gift === MARK) line = i;
      });
      var want = desired(dq), have = line ? line.quantity : 0;
      if (want === have) return null;
      if (!line && want > 0)
        return fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({items:[{id: GIFT_VARIANT, quantity: want, properties: {_auto_gift: MARK}}]})}).then(refresh);
      if (line)
        return fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({id: line.key, quantity: want})}).then(refresh);
    }).catch(function(){});
    setTimeout(function(){ busy = false; }, 900);
  }

  var of = window.fetch;
  window.fetch = function(){
    var args = arguments;
    var u = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    var p = of.apply(this, args);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(sync, 400); });
    return p;
  };
  var ox = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    try { if (!busy && /\/cart\/(add|change|update|clear)/.test(u)) this.addEventListener("load", function(){ setTimeout(sync, 400); }); } catch(e){}
    return ox.apply(this, arguments);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function(){ setTimeout(sync, 600); });
  else setTimeout(sync, 600);
})();
